var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 89.5a39.5 39.5 0 1 0-39.5-39.5 39.501 39.501 0 0 0 39.5 39.5zm-24.395-63.895a34.5 34.5 0 1 1-10.105 24.395 34.381 34.381 0 0 1 10.105-24.395z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.768 65.267 12.232-12.232 12.232 12.232a2.5 2.5 0 1 0 3.5356-3.5355l-12.232-12.232 11.23-11.23a2.5 2.5 0 1 0-3.5356-3.5355l-11.23 11.23-11.23-11.23a2.5 2.5 0 1 0-3.5356 3.5355l11.23 11.23-12.232 12.232a2.5 2.5 0 0 0 3.5356 3.5355z",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d902f8cadfd5bc221ef35c872a064505.svg";
export { ForwardRef as ReactComponent };